/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useEffect, useRef } from 'react';
import { reaction } from 'mobx';

import type { RefObject } from 'react';

import { useGlobalAddons } from '../../providers/GlobalContextProvider';

import type { GridProps, GridStore } from '../../Grid';

export const usePortalFiltersReload = <RowDataT, TotalRowDataT, FilterT>(
    api?: GridProps<RowDataT, TotalRowDataT, FilterT>['api']
): GridProps<RowDataT, TotalRowDataT, FilterT>['api'] => {
    const { portalFilters } = useGlobalAddons();
    const currentGridApi = useRef<GridStore<RowDataT, TotalRowDataT, FilterT>>();
    const gridApi = api ?? currentGridApi;

    useEffect(() => {
        if (portalFilters) {
            return reaction(
                () => [portalFilters.locationFilter, portalFilters.siteFilter.join(','), portalFilters.organizationFilter],
                () => {
                    (gridApi as RefObject<GridStore<RowDataT, TotalRowDataT, FilterT>>).current?.reloadGrid();
                },
            );
        }
    }, [portalFilters]);

    return gridApi;
};
